import * as faker from "faker";
import { Prisma } from "../db";
export const organizationWithoutIds = (args = {})=>{
    const { id, ...organization } = organizationFactory(args);
    return organization;
};
export const organizationFactory = (args)=>({
        name: faker.company.companyName(),
        stripeCustomer: null,
        stripeSubscription: null,
        lastUsageReportDate: null,
        trialEndDate: null,
        hasOrderedIntegrationGift: false,
        localizationIntegration: Prisma.DbNull,
        ...args
    });
